import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="bg-[#f8f5e9] border-t border-gray-200 text-gray-800">
      <div className="pt-10 max-w-[var(--max-width)] mx-auto">
        {/* Top Section - Links */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mx-auto px-4 sm:px-6 lg:px-8">
          {/* About Us */}
          <div>
            <h3 className="text-sm font-semibold italic mb-2">About us</h3>
            <ul className="space-y-1 text-blue-800">
              <li>
                <Link to="/faqs">FAQs</Link>
              </li>
              <li>
                <Link to="/publications">News & Updates</Link>
              </li>
              <li>
                <Link to="/contact-us">Contact Us</Link>
              </li>
              <li>
                <Link to="/team-synopsis">Team Synopsis</Link>
              </li>
              {/* <li>
                <Link to="/feedback-form">Feedback Form</Link>
              </li> */}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-sm font-semibold italic mb-2">Services</h3>
            <ul className="space-y-1 text-blue-800">
              <li>
                <Link to="/regulatory-services/strategic-regulatory-planning">Regulatory Services</Link>
              </li>
              <li>
                <Link to="/gmp-audits-and-compliance/gmp-audits-compliance-and-training-services">GMP Compliance</Link>
              </li>
              <li>
                <Link to="/trainings/regulatory-training-programs">Trainings</Link>
              </li>
              <li>
                <Link to="/pharma-project-management/product-development-api-and-formulations">Pharma Project Management</Link>
              </li>
              <li>
                <Link to="/it-solutions-for-pharma/enterprise-quality-management-system-eqms">IT Solutions for Pharma</Link>
              </li>
            </ul>
          </div>

          {/* Regulatory Services */}
          <div>
            <h3 className="text-sm font-semibold italic mb-2">Regulatory Services</h3>
            <ul className="space-y-1 text-blue-800">
              <li>
                <Link to="/regulatory-services/strategic-regulatory-planning">Regulatory Strategy</Link>
              </li>
              <li>
                <Link to="/regulatory-services/comprehensive-ectd-spl">eCTD SPL</Link>
              </li>
              <li>
                <Link to="/regulatory-services/dossier-management">Dossier Management</Link>
              </li>
              {/* <li>
                <Link to="/regulatory-services/life-cycle-management">Life Cycle Management</Link>
              </li> */}
              <li>
                <Link to="/regulatory-services/regulatory-representation-services">In Country Representative</Link>
              </li>
            </ul>
          </div>

          {/* Regulatory Support Services */}
          <div>
            <h3 className="text-sm font-semibold italic mb-2">Regulatory Support Services</h3>
            <ul className="space-y-1 text-blue-800">
              <li>
                <Link to="/regulatory-services/regulatory-support-services">Regulatory Support Services</Link>
              </li>
              <li>
                <Link to="/regulatory-services/regulatory-representation-services">DCGI Submission</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* Bottom Section - Copyright */}
        <div className="mt-8 flex flex-col md:flex-row justify-center md:justify-between items-center text-sm text-gray-600 space-y-2 md:space-y-0 bg-[#f0eed4] py-4">
          <div className="px-4 sm:px-6 lg:px-8 w-full max-w-[var(--max-width)] mx-auto">
            <span>© 2020 www.fdacadvancedsolutions.com</span>
            <span className="mx-2 text-gray-400">|</span>
            <Link to="/privacy-policy" className="text-blue-800 hover:text-blue-900">Privacy Policy</Link>
            <span className="mx-2 text-gray-400">|</span>
            <Link to="/terms-of-use" className="text-blue-800 hover:text-blue-900">Term of Use</Link>
            <span className="float-right">For tailored support or partnership inquiries, contact: <span className="text-blue-800 hover:text-blue-900">info@fdacadvancedsolutions.com</span></span>
          </div>
        </div>
    </footer>
  );
}

export default Footer;
